'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Record)({
  accentColor: null,
  textColor: null,
  useDefaultColor: false
}, 'ColoringRecord');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/records/ColoringRecord.js
// module id = 329
// module chunks = 2 3